var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeedler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.6308 19.905C87.1838 19.503 88.8263 19.1326 88.8263 19.1326L89.6603 18.2566C89.6603 18.2566 89.4773 17.4046 88.6253 15.8356C87.7748 14.265 85.5248 13.2105 85.5248 13.2105L81.8708 12.3105L79.1063 12.1516L84.6308 7.39055L83.9483 6.96755L85.2428 6.12305L86.1203 4.29005L84.6308 4.32905L83.4623 4.36655L74.4383 12.1516L72.9968 12.3105L73.9013 11.2936L74.4053 10.0951L74.3678 8.05355L73.3118 7.82855L76.8668 3.19505L76.8803 2.12555L75.5483 2.88305L66.2423 13.6141L61.6523 14.8141L66.2423 8.51105L66.0173 4.28405L58.2323 15.8356L56.8688 16.1896L61.2278 9.24005L58.6688 10.6846L53.9123 17.0866L53.2148 16.6965L59.0093 7.52405L58.8503 6.62705L56.2523 8.72705L50.1233 18.2866L44.6168 21.7216V22.6231L43.5188 23.5515L40.3673 23.6026L36.0863 25.5781L33.9458 25.4296L32.4443 26.3055L29.2883 31.8286L33.6638 32.364C33.6638 32.364 33.4103 33.1891 33.2138 34.0531C33.0158 34.9186 33.6083 36.0796 33.6083 36.0796L29.6108 36.1921L31.8068 41.9926C31.8068 41.9926 36.7628 43.4565 37.4078 43.803C38.0543 44.1495 40.4213 45.183 40.4213 45.183C40.4213 45.183 43.2488 46.218 43.9133 46.6665C44.5778 47.1165 44.2928 47.661 44.2928 47.661C44.2928 47.661 62.1488 55.7071 65.2283 56.8891C68.3078 58.0711 72.9698 58.437 72.9698 58.437L73.8983 57.8655L83.2193 58.437L87.2168 57.1981L88.8038 53.4196L79.0508 50.4225L77.9258 49.6516L68.7473 45.09C68.7473 45.09 71.0498 39.2911 71.1128 38.6145C71.1758 37.938 70.8878 34.6591 70.8878 34.6591C70.8878 34.6591 70.6463 31.4821 70.5308 29.7676C70.4153 28.0531 69.5423 27.0136 69.5423 27.0136L68.4113 24.5926C68.4113 24.5926 75.0938 21.795 76.0133 21.777C76.9328 21.759 82.0763 20.3056 84.6293 19.9036L84.6308 19.905ZM42.8468 37.8691C42.8468 37.8691 40.4813 38.2066 39.2993 38.1226C38.1173 38.0386 34.4288 36.87 33.6113 36.081H42.8468V37.8691V37.8691ZM43.0583 32.364H33.6683C33.6683 32.364 35.7098 31.0696 36.0893 30.9001C36.4688 30.7306 39.1718 30.054 39.5948 30.0975C40.0178 30.141 43.0583 30.4366 43.0583 30.4366V32.3656V32.364ZM64.4708 38.6716C64.4138 39.6286 63.4808 41.3055 63.4808 41.3055L58.1408 39.5311C58.1408 39.5311 57.3188 38.3895 57.1508 37.827C56.9813 37.2645 56.3618 36.8131 56.3618 36.8131C56.3618 36.8131 56.6438 35.5741 56.6993 34.7296C56.7563 33.8851 56.3618 32.589 56.3618 32.589C56.3618 32.589 56.8118 31.8256 57.3758 31.1656C57.9383 30.5056 59.8583 29.9986 60.4193 29.7736C60.9803 29.5486 62.4068 28.3486 62.4068 28.3486L61.9493 27.5611C61.9493 27.5611 62.1428 27.8776 62.4068 28.3486C62.9078 29.2426 63.6668 30.69 63.8513 31.5765C64.1333 32.9281 64.5263 37.7146 64.4708 38.6716V38.6716Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7395 26.557L49.9736 27.2695L49.1193 28.7491C48.9228 29.0895 48.4864 29.2064 48.146 29.0099C47.8057 28.8134 47.6888 28.377 47.8853 28.0366L48.7395 26.557V26.557Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1423 29.3726L51.3766 30.696L50.0399 30.9327C49.7342 30.9868 49.4421 30.7826 49.388 30.4769L49.3508 30.2671C49.2962 29.9584 49.5028 29.6629 49.8115 29.6082L51.1438 29.3723L51.1423 29.3726Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1468 29.0115C48.1468 29.0115 46.4983 30.627 46.4878 32.4645",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3855 30.477C49.3855 30.477 47.548 31.3395 47.467 32.694",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.012 31.9995H49.2655",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1466 39.1318C48.4869 38.9353 48.9234 39.0523 49.1199 39.3926L49.9741 40.8722L48.74 41.5847L47.8858 40.1051C47.6893 39.7648 47.8062 39.3283 48.1466 39.1318Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3496 37.8775L49.3867 37.6677C49.4409 37.362 49.7329 37.1578 50.0387 37.2119L51.3754 37.4486L51.1411 38.772L49.8088 38.5361C49.5001 38.4815 49.2935 38.1859 49.3481 37.8772L49.3496 37.8775Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1468 39.132C48.1468 39.132 46.4983 37.5165 46.4878 35.679",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3855 37.6665C49.3855 37.6665 47.548 36.804 47.467 35.4495",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.012 36.1441H49.2655",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1868 33.1606C51.1868 33.1606 53.9738 31.9786 54.0383 31.9996C54.1028 32.0206 56.5163 32.0836 56.5163 32.0836",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2541 36.771L54.0371 36.666L51.3341 35.145",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7971 40.3184C54.7971 40.3814 55.1136 41.5649 55.1136 41.5649",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7903 41.103L57.2468 40.6785",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2542 41.7765L56.6352 43.3605",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5998 42.2625L54.1643 42.768",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6389 30.096H33.7794",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 27.963H35.9757",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3586 38.334H33.9476",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1604 40.5584H35.6939",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3443 30.2866L53.8508 26.8471L54.5393 25.7911L58.2188 24.7771L59.9918 22.9606L64.2998 21.7786L68.4113 24.5941",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5972 23.604C70.5972 23.604 70.7622 19.794 71.3532 18.9075C71.9442 18.021 72.3672 17.43 72.3672 17.43C72.3672 17.43 76.2522 16.1685 80.0112 16.377L81.4887 17.0505L83.1357 19.98",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7605 19.7505L84.4465 15.612C84.4465 15.612 82.5655 12.966 81.373 12.3045",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1379 24.8609L52.8549 21.7784C52.8549 21.7784 56.9094 18.6959 57.2049 18.4004C57.5004 18.1049 68.9454 15.4019 69.1989 15.4019C69.4524 15.4019 81.8844 13.1609 87.3669 14.2604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7908 18.2564C71.7908 18.2564 68.5223 14.7434 66.7913 13.8269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4182 24.477L55.4307 23.604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1565 22.3064L56.2125 22.7924",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6351 23.3835L57.5006 22.3065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8743 23.8274L57.0668 24.3974",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5152 29.0115L56.2122 27.5625L56.8662 26.7C56.8662 26.7 58.2807 26.34 58.7667 26.034C59.2527 25.728 62.6307 23.604 62.6307 23.604H63.3912L66.2427 25.812",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0551 24.3975L63.8786 25.431",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0831 24.861L63.0551 26.0325",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.344 25.326L62.0835 26.445",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5198 25.8855L61.1303 26.931",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.76 26.409L60.162 27.2475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8518 26.8274L59.1683 27.5609",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8801 27.015L58.1546 27.7125",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0667 27.4561L57.2886 28.0921",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4661 27.015C63.4661 27.015 67.1996 26.043 68.7491 29.211C70.2971 32.379 68.1431 34.152 67.3841 34.659C66.6236 35.166 64.2881 35.2815 64.2881 35.2815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3838 34.6604C67.3838 34.6604 68.0738 36.4244 67.7078 37.9424C67.3418 39.4604 66.0188 42.5684 66.0188 42.5684",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0372 31.9995C54.0372 31.9995 55.4727 33.435 54.0372 36.666",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7795 46.668C45.7795 46.668 49.153 46.218 52.1935 48.357C55.234 50.4975 55.6855 52.8495 55.6855 52.8495",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6428 48L53.7953 47.5125L63.1463 52.1865C63.1463 52.1865 67.5098 49.7655 68.4113 48.9765C69.3128 48.1875 70.1243 45.774 70.1243 45.774",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1466 52.1865L76.0136 56.7765",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8662 15.1245L87.0217 15.6975L88.1287 19.4085",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3667 24.477L44.8722 24.861",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9722 44.337L44.6187 44.697",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2161 34.0545L50.1271 34.1115",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1057 12.1516C83.2457 12.2941 86.7377 13.0606 88.1222 15.0766C90.0932 17.949 89.7557 18.4545 89.3612 18.7935C88.9667 19.131 88.0097 19.5825 86.8277 19.638C85.6457 19.6935 76.2977 21.0466 73.0307 22.5106C69.7637 23.9746 68.4137 24.5941 68.4137 24.5941C68.4137 24.5941 70.6097 28.9305 70.6097 30.3375C70.6097 31.7445 71.1167 38.616 71.1167 38.616C71.1167 38.616 71.1737 39.405 70.6097 40.6995C70.0457 41.994 68.7512 45.0915 68.7512 45.0915L77.9297 49.653L78.3797 50.2155L89.1917 53.538L87.2207 57.198L83.2232 58.437L73.6502 57.987L72.9752 58.437C72.9752 58.437 67.1192 57.5355 64.5842 56.691C62.0507 55.8465 43.9742 47.5125 43.9742 47.5125L43.9172 46.668C43.9172 46.668 42.7352 45.711 41.2712 45.429C39.8072 45.147 36.7667 43.458 36.7667 43.458L31.8107 41.994C31.8107 41.994 29.3897 36.363 29.6147 36.1935C29.8397 36.024 33.6122 36.081 33.6122 36.081C33.6122 36.081 33.1622 34.56 33.2177 34.0545C33.2732 33.549 33.6677 32.3656 33.6677 32.3656L29.2922 31.83L32.2037 26.424C32.2037 26.424 33.5552 25.749 34.4837 25.5795C35.4122 25.41 36.0887 25.5795 36.0887 25.5795L40.4807 23.553H43.5212L44.6192 22.6245V21.7231L50.1257 18.288",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9963 12.3105C73.2048 12.2895 73.4028 12.273 73.5918 12.261C74.0718 12.231 74.3283 12.2685 74.8053 12.2475",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6545 14.8139C64.272 14.0909 66.9645 13.4039 69.2925 12.9209",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8694 16.1895C57.2594 16.0725 57.6599 15.954 58.0679 15.8355",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7499 45.0915L64.6954 41.7135C64.6954 41.7135 56.6434 39.0105 55.4599 38.673C54.2779 38.3355 51.2359 35.835 51.1804 35.283C51.1804 35.283 52.0819 39.2355 49.4914 42.615C46.9009 45.993 43.9729 47.514 43.9729 47.514",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6191 22.623C44.6191 22.623 47.2936 22.905 49.2091 25.2135C51.1246 27.522 51.8551 30.507 51.1801 33.0405C51.1801 33.0405 52.4746 31.4895 52.7566 31.167C53.0386 30.8445 58.1056 28.311 60.8086 28.086C60.8086 28.086 61.2616 27.8775 61.9486 27.5625C63.8941 26.6685 67.7146 24.912 68.4106 24.5955",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6488 57.987C73.6488 57.987 76.4643 56.664 76.6338 56.3265C76.8033 55.989 78.3798 50.217 78.3798 50.217",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6682 32.3655C33.6682 32.3655 35.7097 31.071 36.0892 30.9015C36.4687 30.732 39.1717 30.0555 39.5947 30.099C40.0177 30.1425 43.0582 30.438 43.0582 30.438V32.367H33.6682V32.3655Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6108 36.081H42.8463V37.869C42.8463 37.869 40.4808 38.2065 39.2988 38.1225C38.1168 38.0385 34.4283 36.87 33.6108 36.081V36.081Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0574 32.3655C43.0574 32.3655 47.3654 32.394 48.7589 33.0405C50.1524 33.687 50.1434 33.6885 50.1269 34.11C50.1104 34.5315 49.2659 34.9125 48.8429 35.082C48.4199 35.2515 44.2394 36.081 42.8459 36.081",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0576 30.4366L48.5026 24.4771",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8459 37.8689L48.0029 44.3369",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8567 20.8215L58.6697 10.686L61.6547 8.60254L54.4472 19.4145C54.4472 19.4145 53.5457 21.273 51.8567 20.823V20.8215Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6038 19.5255L51.8568 18.738L59.4768 7.30655L58.2753 7.86905L59.4768 6.12305L55.8543 9.05255L49.6038 19.5255Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8811 16.3725L65.5401 4.71602L68.4126 2.12552L65.4846 6.68702L67.7376 4.99802L64.9776 8.60252L66.9486 7.70102L61.6551 14.814C61.6551 14.814 59.2371 16.452 57.8826 16.3725H57.8811Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6799 14.7466L73.3679 8.60106L76.3529 6.96756L73.4249 10.4596L75.3959 9.72756L70.6094 14.7466C70.6094 14.7466 68.8634 15.5986 67.6814 14.7466H67.6799Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.592 13.3876L82.8275 4.7161L85.5875 3.1951L84.0665 4.9966L87.5015 3.8146L83.504 7.3621L85.3055 6.9676L77.366 13.3876C77.366 13.3876 74.9405 14.3746 73.5935 13.3876H73.592Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4963 13.2195L74.9998 3.19502L77.8723 1.56302L76.3513 3.19502L77.8723 2.57552L68.9743 12.825L66.4963 13.2195Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5657 17.196C53.5657 17.196 53.6287 17.1765 54.2632 16.98",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9491 27.5611C61.9491 27.5611 62.1426 27.8776 62.4066 28.3486C62.9076 29.2426 63.6666 30.6901 63.8511 31.5766C64.1331 32.9281 64.5261 37.7146 64.4706 38.6716C64.4151 39.6286 63.4806 41.3056 63.4806 41.3056L58.1406 39.5311C58.1406 39.5311 57.3186 38.3896 57.1506 37.8271C56.9826 37.2646 56.3616 36.8131 56.3616 36.8131C56.3616 36.8131 56.6436 35.5741 56.6991 34.7296C56.7546 33.8851 56.3616 32.5891 56.3616 32.5891C56.3616 32.5891 56.8116 31.8256 57.3756 31.1656C57.9381 30.5056 59.8581 29.9986 60.4191 29.7736C60.9801 29.5486 62.4066 28.3486 62.4066 28.3486",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedler);
export default __webpack_public_path__ + "static/media/Needler.adf998413bee476b29bbeeae11c2f649.svg";
export { ForwardRef as ReactComponent };